"use client";

import { Accordion } from "@/components/ui/accordion";
import { HolidayDurationFilter } from "./holiday-duration-filter";
import { HolidayNameFilter } from "./holiday-name-filter";
import { HolidayPriceRangeFilter } from "./holiday-price-range-filter";
import { HolidayTypeFilter } from "./holiday-type-filter";

export function HolidayFilterSection() {
  return (
    <Accordion
      className="space-y-2 py-2"
      type="multiple"
      defaultValue={["holiday_name", "price", "holiday_type", "duration"]}
    >
      <HolidayNameFilter />
      <HolidayPriceRangeFilter />
      <HolidayTypeFilter />
      <HolidayDurationFilter />
    </Accordion>
  );
}
